var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isOverlayVisible
    ? _c(
        "div",
        {
          staticClass: "chat-overlay",
          class: { "desktop-side-panel": !_vm.isMobile, closing: _vm.isClosing }
        },
        [
          _c(
            "div",
            {
              staticClass: "overlay-content",
              class: {
                "desktop-content": !_vm.isMobile,
                closing: _vm.isClosing
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "top-toolbar",
                  class: { "desktop-content": !_vm.isMobile }
                },
                [
                  _vm.isMobile
                    ? [
                        _c(
                          "button",
                          {
                            staticClass: "back-button",
                            on: { click: _vm.closeOverlay }
                          },
                          [
                            _c("InlineSvg", {
                              attrs: {
                                src: "/images/stanley/chevron-left-large.svg"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("ChatSelector", {
                          attrs: {
                            chats: _vm.availableChats,
                            currentChatId: _vm.activeChatId
                          },
                          on: { "chat-selected": _vm.switchToChat }
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "create-new-button",
                            on: { click: _vm.startNewChat }
                          },
                          [
                            _c("InlineSvg", {
                              attrs: { src: "/images/stanley/write-dark.svg" }
                            })
                          ],
                          1
                        )
                      ]
                    : [
                        _c(
                          "button",
                          {
                            staticClass: "create-new-button",
                            on: { click: _vm.startNewChat }
                          },
                          [
                            _c("InlineSvg", {
                              attrs: { src: "/images/stanley/write-dark.svg" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("ChatSelector", {
                          attrs: {
                            chats: _vm.availableChats,
                            currentChatId: _vm.activeChatId
                          },
                          on: { "chat-selected": _vm.switchToChat }
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "close-button",
                            on: { click: _vm.closeOverlay }
                          },
                          [
                            _c("InlineSvg", {
                              attrs: { src: "/images/icons-2025/x-close.svg" }
                            })
                          ],
                          1
                        )
                      ]
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "checklist-wrapper",
                  class: {
                    "checklist-wrapper-minimized": _vm.checklistMinimized
                  }
                },
                [
                  _c("DynamicDashboardChecklist", {
                    attrs: { minimized: _vm.checklistMinimized },
                    on: { "minimized-clicked": _vm.maximizeChecklist }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "main-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "chat-container",
                    class: { hidden: !_vm.isChatTabActive }
                  },
                  [
                    _c(
                      "div",
                      {
                        ref: "messagesContainer",
                        staticClass: "messages-container",
                        on: { scroll: _vm.handleScroll }
                      },
                      _vm._l(_vm.chatMessages, function(message) {
                        return _c(
                          "div",
                          {
                            key: message.id,
                            staticClass: "message",
                            class: message.type
                          },
                          [
                            message.type === _vm.messageTypes.RECEIVED
                              ? _c(
                                  "div",
                                  { staticClass: "ai-message-header" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "stanley-icon" },
                                      [
                                        _c("InlineSvg", {
                                          attrs: {
                                            src:
                                              "/images/dynamic_onboarding_v2/onboarding-stanley.svg"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    message.id === _vm.currentMessage?.id &&
                                    (_vm.isAIResponding || _vm.isAIStreaming) &&
                                    !message.content
                                      ? _c(
                                          "div",
                                          { staticClass: "thinking-indicator" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "thinking-text" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "gradient-text"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.currentStatus)
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("ChatMessageContent", {
                              attrs: { message: message },
                              on: {
                                "view-product": _vm.handleViewProduct,
                                "view-image": _vm.handleViewImage,
                                "preview-attachment-image":
                                  _vm.handlePreviewAttachmentImage
                              }
                            }),
                            _vm._v(" "),
                            message.type === _vm.messageTypes.RECEIVED &&
                            message.content
                              ? _c("MessageActionMenu", {
                                  attrs: {
                                    message: message,
                                    "feedback-status":
                                      message.feedback_status || 0,
                                    "is-disabled":
                                      _vm.isAIResponding || _vm.isAIStreaming,
                                    "show-checkmark":
                                      _vm.copiedMessageId === message.id
                                  },
                                  on: {
                                    "thumbs-up": _vm.handleThumbsUp,
                                    "thumbs-down": _vm.handleThumbsDown,
                                    refresh: _vm.handleRefresh,
                                    copy: _vm.handleCopy
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.chatMessages.length === 0
                      ? _c("div", { staticClass: "action-buttons-container" }, [
                          _c(
                            "div",
                            { staticClass: "action-buttons-title" },
                            [
                              _c(
                                "div",
                                { staticClass: "action-buttons-icon" },
                                [
                                  _c("InlineSvg", {
                                    attrs: {
                                      src:
                                        "/images/dynamic_onboarding_v2/onboarding-stanley.svg"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "spacer",
                                    staticStyle: { height: "4px" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("TypingTitle", {
                                attrs: { title: "How can I help?" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "action-buttons-scroll-container" },
                            [
                              _c(
                                "div",
                                { staticClass: "action-buttons-wrapper" },
                                [
                                  _c("ActionButton", {
                                    attrs: {
                                      text: "Create a Product",
                                      "icon-src":
                                        "images/icons-2025/ai-generate-product.svg"
                                    },
                                    on: { click: _vm.createProduct }
                                  }),
                                  _vm._v(" "),
                                  _c("ActionButton", {
                                    attrs: {
                                      text: "Create a Marketing Post",
                                      "icon-src":
                                        "images/icons-2025/ai-document.svg"
                                    },
                                    on: { click: _vm.createMarketingPost }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "preview-container",
                    class: { hidden: !_vm.isPreviewTabActive }
                  },
                  [
                    _c("div", { staticClass: "preview-content" }, [
                      _c("div", { staticClass: "preview-placeholder" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "48",
                              height: "48",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }
                            }),
                            _vm._v(" "),
                            _c("polyline", {
                              attrs: {
                                points: "14,2 14,8 20,8",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", [_vm._v("Preview content will appear here")])
                      ])
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "bottom-input-area",
                  class: { "desktop-content": !_vm.isMobile }
                },
                [
                  _c("FileAttachmentPreview", {
                    attrs: { attachments: _vm.attachments },
                    on: {
                      "remove-attachment": _vm.removeAttachment,
                      "preview-image": _vm.previewAttachmentImage
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-container" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.messageText,
                          expression: "messageText"
                        }
                      ],
                      ref: "messageInput",
                      staticClass: "message-input",
                      style: { height: _vm.inputHeight + "px" },
                      attrs: { placeholder: "Ask Stanley..." },
                      domProps: { value: _vm.messageText },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) return
                            _vm.messageText = $event.target.value
                          },
                          _vm.adjustInputHeight
                        ],
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.handleEnterKey.apply(null, arguments)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      ref: "fileInput",
                      staticStyle: { display: "none" },
                      attrs: {
                        type: "file",
                        multiple: "",
                        accept: _vm.getAcceptedFileTypes()
                      },
                      on: { change: _vm.handleFileSelect }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "bottom-toolbar" }, [
                    _c(
                      "button",
                      {
                        staticClass: "plus-button",
                        attrs: {
                          disabled:
                            _vm.attachments.length >= _vm.maxAttachments ||
                            _vm.isAIResponding ||
                            _vm.isAIStreaming,
                          title:
                            _vm.attachments.length >= _vm.maxAttachments
                              ? "Maximum 10 files allowed"
                              : "Add files"
                        },
                        on: { click: _vm.openFileDialog }
                      },
                      [
                        _c("InlineSvg", {
                          attrs: { src: "/images/icons-2025/plus.svg" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isAIResponding || _vm.isAIStreaming
                      ? _c(
                          "button",
                          {
                            staticClass: "round-button primary",
                            on: { click: _vm.handleStopStreaming }
                          },
                          [
                            _c("InlineSvg", {
                              attrs: { src: "/images/stanley/stop-white.svg" }
                            })
                          ],
                          1
                        )
                      : _vm.messageText.trim() || _vm.attachments.length > 0
                      ? _c(
                          "button",
                          {
                            staticClass: "round-button primary",
                            on: { click: _vm.handleSendMessage }
                          },
                          [
                            _c("InlineSvg", {
                              attrs: {
                                src: "/images/stanley/up-arrow-white.svg"
                              }
                            })
                          ],
                          1
                        )
                      : _c(
                          "button",
                          { staticClass: "round-button" },
                          [
                            _c("InlineSvg", {
                              attrs: {
                                src: "/images/stanley/up-arrow-purple.svg"
                              }
                            })
                          ],
                          1
                        )
                  ])
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _vm.isImageViewerOpen
            ? _c("ChatImageViewer", {
                attrs: {
                  imageSrc: _vm.selectedImageSrc,
                  imageAlt: _vm.selectedImageAlt,
                  imageFilename: _vm.selectedImageFilename
                },
                on: { close: _vm.closeImageViewer }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isAttachmentImageViewerOpen
            ? _c("ChatImageViewer", {
                attrs: {
                  imageSrc: _vm.selectedAttachmentImageSrc,
                  imageAlt: _vm.selectedAttachmentImageAlt,
                  imageFilename: _vm.selectedAttachmentImageFilename,
                  imageType: "attachment"
                },
                on: { close: _vm.closeAttachmentImageViewer }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }